export default __webpack_public_path__ + "static/hero_bg-93cca7d39998b2b595acc437d9577239.jpg";